import React, { useEffect } from 'react';
import Layout from '@shared/ui/organisms/layout/Layout';
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RoomFinderView } from "../components/RoomFinderView";
import { refreshBookings, selectedOffice, setOffice } from "../models/room-finder.duck";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { getRootOfficeById } from '@shared/utils/OfficeHelper';
import { loadMeetingRooms } from '@features/settings/pages/meeting-rooms/meeting-rooms-settings.duck';
import { addOrReplaceQueryParam, deleteQueryParam, getParameterByName } from '@shared/utils/UrlUtils';
import { breakpoints, desktopSmall } from '@shared/ui/atoms/MediaQueries';
import { RoomFinderSidebar } from "../components/RoomFinderSidebar";
import { WithDefaultOfficeSelection } from '@shared/hooks/WithDefaultOfficeSelection';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { MeetingRoomFinderPageHeader } from "../components/MeetingRoomFinderPageHeader";
import { isInTeams } from '@shared/utils/TeamsUtils';
import moment from "moment";
import { selectActiveDay, setActiveDay } from '@features/whereabouts/store/editMovements.duck';

export function RoomFinderPage(props: Props) {
  const office = useSelector(selectedOffice)
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const allOffices = useSelector(selectAllOfficeEntities);
  const activeDay = useSelector(selectActiveDay);

  WithDefaultOfficeSelection(true, true);

  useEffect(() => {
    dispatch(loadMeetingRooms());
  }, [dispatch]);

  useEffect(() => {
    if (office) return;

    const officeQueryParam = getParameterByName('office', window.location.href);
    if (officeQueryParam) {
      try {
        const officeId = parseInt(officeQueryParam);
        const officeToSet = getRootOfficeById(allOffices, officeId);
        if (officeToSet) {
          dispatch(setOffice(officeToSet));
        }
      } catch (e) {
        deleteQueryParam('office');
      }
    } else if (!office && !!currentUser?.defaultLocationId) {
      const defaultOffice = getRootOfficeById(allOffices, currentUser.defaultLocationId);
      if (defaultOffice) {
        dispatch(setOffice(defaultOffice));
      }
    } else {
      const rootOffices = allOffices.filter((o: OfficeEntity) => o.office && !o.parentId)
      if (rootOffices.length > 0) {
        const defaultMeetingRoom = rootOffices[0];
        dispatch(setOffice(defaultMeetingRoom));
      }
    }
  }, [currentUser, office, dispatch, allOffices]);

  useEffect(() => {
    if (office) {
      addOrReplaceQueryParam('office', office.id.toString());
    }
  }, [office]);

  useEffect(() => {
    const dateParam = getParameterByName('date', window.location.href);
    if (dateParam) {
      dispatch(setActiveDay(moment(dateParam)));
    }
  }, [dispatch]);


  return (
    <>
      <Layout hideFooter={true} fullScreenView={true} style={{maxWidth: '100%'}}>
        <RoomFinderContainer isInTeams={isInTeams()}>
          <ContentContainer>
            <HeaderRowWrapper>
              <MeetingRoomFinderPageHeader className={'roomFinderView__header'} />
            </HeaderRowWrapper>
            <RoomFinderView />
          </ContentContainer>
          <RoomFinderSidebar />
        </RoomFinderContainer>
      </Layout>
    </>
  )
}

interface Props {
}

const RoomFinderContainer = styled.div<any>`
  max-height: inherit;
  position: relative;
  display: flex;
  
  width: 100%;
  margin: 0 auto;
  max-width: ${breakpoints.desktopUberWide}px;
  height: calc(100vh - ${props => props.isInTeams ? '65px' : '114px'});
  
  .roomFinderView__header {
    max-width: ${breakpoints.desktopUberWide}px;
  }
  
  @media (${desktopSmall}) {
    .roomFinderSidebar__closeBtn {
      display: none !important;
    }
  }
  
  .roomFinderView__container {
    overflow: auto;
    height: calc(100vh - (${props => props.isInTeams ? '65px' : '114px'} + 175px));
    max-width: 100%;
    @media (${desktopSmall}) {
      height: calc(100vh - (${props => props.isInTeams ? '65px' : '114px'} + 72px));
    }
  }
  .roomFinderView__sidebar {
    flex: 0 0 360px !important;
    order: 2;
  }
`


const HeaderRowWrapper = styled.div`
  max-height: 170px;
  height: 170px;
  margin-left: 0;
  @media (${desktopSmall}) {
    max-height: 72px;
    height: 72px;
    margin-left: 92px;
  }
`


const ContentContainer = styled.div`
  flex: 1 !important;
  order: 1;
  overflow: hidden;
`
